"use client";
// 2026-09-12 MinimalLoader — loader de ruta minimalista (websearch 2026:
// industry pattern: marca centrada con pulso suave en fondo plano
// para transiciones cortas <2s; NN/g 2026: skeleton solo para contenido
// estructurado, nunca para el shell de la app). Sin esqueleto, sin textura,
// sin texto visible — solo LogoMark con breathing + etiqueta sr-only.
import { LogoMark } from "@/components/ui/logo";
import { useT } from "@/lib/use-i18n";
import { cn } from "@/lib/utils";

export function MinimalLoader({ className }: { className?: string }) {
  const t = useT();
  return (
    <main
      id="main"
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn("flex min-h-screen items-center justify-center bg-background", className)}
    >
      <span className="loader-pulse" aria-hidden="true">
        <LogoMark size={32} />
      </span>
      <span className="sr-only">{t("loadingSrOnly")}</span>
    </main>
  );
}
